import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {PanelDynamicRegionBehavior} from '../behaviors/panel-dynamic-region-behavior.js';
import {PanelfullregionobjectsSharedStylesHTML} from '../shared-styles/panel-full-region-objects.js';

class KeliPanelFooter extends ScopeBinding(PanelDynamicRegionBehavior(PolymerElement)) {
  static get template() {
    return html`
${PanelfullregionobjectsSharedStylesHTML}
<style>
  :host {
    display: none;
    flex: var(--keli-panel-footer-flex, .5);
    flex-direction: column;
    overflow: auto;
    border-top: 2px solid var(--keli-subtle-border-color);
  }
  
  :host(.visible) {
    display: flex;
  }
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-panel-footer';
  }

  static get properties() {
    return {
      flex: {type: Number, scopevar: true, observer: 'flexChanged'}
    }
  }

  flexChanged(newValue) {
    this.updateStyles({'--keli-panel-footer-flex': newValue || ''});
  }

  handleRegionVisibilityChanged(newValue) {
    this.classList.toggle('visible', newValue);
  }
}

customElements.define(KeliPanelFooter.is, KeliPanelFooter);
export {KeliPanelFooter};
